import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminSettlements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/settlements").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  const totals = items.reduce((acc, v) => ({
    gross: acc.gross + v.gross,
    commission: acc.commission + v.commission,
    net: acc.net + v.net_payable,
  }), { gross: 0, commission: 0, net: 0 });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Finance</div>
      <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">Vendor Settlements</h1>

      <div className="mt-6 grid grid-cols-3 gap-4">
        <div className="rounded-xl border border-[#E2E8E5] bg-white p-5">
          <div className="text-xs uppercase tracking-widest text-[#6E877C]">Total Gross</div>
          <div className="font-display text-2xl text-[#0F3D2E]">₹{totals.gross.toLocaleString()}</div>
        </div>
        <div className="rounded-xl border border-[#E2E8E5] bg-white p-5">
          <div className="text-xs uppercase tracking-widest text-[#6E877C]">Platform Commission</div>
          <div className="font-display text-2xl text-[#14A085]">₹{totals.commission.toLocaleString()}</div>
        </div>
        <div className="rounded-xl border border-[#E2E8E5] bg-white p-5">
          <div className="text-xs uppercase tracking-widest text-[#6E877C]">Vendor Payables</div>
          <div className="font-display text-2xl text-[#0F3D2E]">₹{totals.net.toLocaleString()}</div>
        </div>
      </div>

      {loading ? (
        <div className="mt-8 text-center text-[#3B5249]">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#E2E8E5] bg-white p-12 text-center">No settlements yet.</div>
      ) : (
        <div className="mt-6 rounded-xl border border-[#E2E8E5] bg-white overflow-hidden" data-testid="settlements-table">
          <table className="w-full text-sm">
            <thead className="bg-[#F9F9F7]">
              <tr className="text-left text-xs text-[#6E877C] uppercase tracking-widest">
                <th className="p-4">Vendor</th>
                <th className="p-4">Orders</th>
                <th className="p-4">Delivered</th>
                <th className="p-4 text-right">Gross Sales</th>
                <th className="p-4 text-right">Commission (1%)</th>
                <th className="p-4 text-right">Net Payable</th>
              </tr>
            </thead>
            <tbody>
              {items.map((v) => (
                <tr key={v.vendor_id} className="border-t border-[#E2E8E5]">
                  <td className="p-4 font-medium text-[#0F3D2E]">{v.vendor_name || v.vendor_id}</td>
                  <td className="p-4">{v.orders}</td>
                  <td className="p-4">{v.delivered}</td>
                  <td className="p-4 text-right">₹{v.gross.toLocaleString()}</td>
                  <td className="p-4 text-right text-[#14A085]">₹{v.commission.toLocaleString()}</td>
                  <td className="p-4 text-right font-semibold text-[#0F3D2E]">₹{v.net_payable.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
